var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfShadedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7199 7.99953L16.8929 7.0056L13.8421 0.83069C13.5678 0.278918 13.0329 0 12.4979 0C11.9662 0 11.4349 0.275187 11.1597 0.83069L8.10795 7.00513L1.28052 7.99813C0.0561778 8.17537 -0.434494 9.68144 0.453099 10.5443L5.392 15.3484L4.22316 22.1339C4.05711 23.1031 4.8309 23.8806 5.6975 23.8806C5.92745 23.8806 6.16392 23.826 6.39107 23.7057L12.4988 20.5023L18.6061 23.7066C18.8328 23.8256 19.0688 23.8797 19.2978 23.8797C20.1653 23.8797 20.9405 23.1049 20.7745 22.1353L19.607 15.3493L24.5469 10.5462C25.4349 9.6833 24.9442 8.17677 23.7199 7.99953ZM18.0417 13.7458L17.1966 14.5676L17.3962 15.7281L18.3066 21.0196L13.5431 18.5201L12.4993 17.9725L12.5007 3.17817L14.8808 7.9958L15.4023 9.05131L16.5688 9.22108L21.8967 9.99673L18.0417 13.7458Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfShadedStar);
export default __webpack_public_path__ + "static/media/half-shaded-star.574a702f41bdd2d943bb13cab3346be5.svg";
export { ForwardRef as ReactComponent };